import React from "react";
import { menuItemsData } from "./MenuItemsData";
import { menuItemsDataSa } from "./MenuItemsDataSa";
import MenuItems from "./MenuItems";
import "./NavBar.css";

const NavBar = ({ isOpen, animated, onToggle }) => {
  const depthLevel = 0;
  const userRole = localStorage.getItem("user_roles");

  const handleSidebarClick = (e) => {
    if (window.innerWidth <= 768 && e.target.closest("a")) {
      onToggle();
    }
  };

  return (
    <>
      {/* Mobile overlay backdrop */}
      <div
        className={`sidebar-overlay${isOpen ? " active" : ""}`}
        onClick={onToggle}
      />

      {/* Mobile open button — shown when drawer is closed */}
      <button
        className={`sidebar-mobile-open-btn${isOpen ? " sidebar-mobile-open-btn--hidden" : ""}`}
        onClick={onToggle}
        aria-label="Open menu"
      >
        &#9776;
      </button>

      <aside
        id="leftsidebar"
        className={`sidebar${isOpen ? " sidebar--open" : " sidebar--closed"}${animated ? " sidebar--animated" : ""}`}
        onClick={handleSidebarClick}
      >
        {/* <div className="sidebar-toggle-wrap">
                <img
                    className="sidebar-logo"
                    src="/assets/images/idlink_logo_navbar.png"
                    alt="Logo"
                />
                <button
                    className="sidebar-toggle-btn"
                    onClick={onToggle}
                    aria-label={isOpen ? 'Close menu' : 'Open menu'}
                >
                    &#9776;
                </button>
            </div> */}

        <div className="container">
          <div className="row clearfix">
            <div className="col-12">
              <div className="menu">
                <nav className="desktop-nav">
                  <ul className="list menus">
                    {userRole == "sa" &&
                      menuItemsDataSa.map((menu, index) => {
                        return (
                          <MenuItems
                            items={menu}
                            key={index}
                            depthLevel={depthLevel}
                          />
                        );
                      })}

                    {userRole != "sa" &&
                      menuItemsData.map((menu, index) => {
                        return (
                          <MenuItems
                            items={menu}
                            key={index}
                            depthLevel={depthLevel}
                          />
                        );
                      })}
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </aside>
    </>
  );
};

export default NavBar;
